// This file is AUTOGENERATED, do not edit it manually!!!

export const filters = {
    Activity_Text: 'Задача',
    ActivityActualBilling: 'Фактическая выручка активности',
    ActivityActualCompletionDateCondition_Text: 'Факт. дата окончания задачи',
    ActivityActualCost: 'Факт. стоимость активности',
    ActivityActualGreaterThanEstimated_Text: 'Задачи с превышением времени',
    ActivityActualHours: 'Фактические часы активности',
    ActivityActualLaborBilling: 'Фактические оплачиваемые трудозатраты активности',
    ActivityActualLaborCost: 'Фактические трудозатраты активности',
    ActivityBillableHours: 'Оплачиваемые часы активности',
    ActivityBilled: 'Оплачено по активности',
    ActivityBilledLabor: 'Оплачено за трудозатраты активности',
    ActivityBilledPercentage: 'Оплачено по активности, %',
    ActivityBudgetVariance: 'Отклонение бюджета активности',
    ActivityCreationDateCondition_Text: 'Дата создания задачи',
    ActivityCreator_Text: 'Создатели активностей',
    ActivityCreatorCondition_Empty_Text: 'Система',
    ActivityCreatorCondition_Text: 'Создатель активности',
    ActivityCustomFieldCondition_Text: 'Дополнительные поля задачи',
    ActivityDuration: 'Длительность активности',
    ActivityEACBillableExpenses: 'EAC оплачиваемые затраты активности',
    ActivityEACBilling: 'EAC сумма к оплате активности',
    ActivityEACCost: 'Ожидаемая итоговая стоимость активности',
    ActivityEACExpenses: 'EAC затраты активности',
    ActivityEACLaborBilling: 'EAC сумма к оплате по трудозатратам активности',
    ActivityEACLaborCost: 'EAC трудозатраты активности',
    ActivityEACNonBillableExpenses: 'EAC неоплачиваемые затраты активности',
    ActivityEndDateCondition_Text: 'Дата окончания задачи',
    ActivityEstimatedExpensesAmount: 'Ожидаемые расходы активности',
    ActivityEstimatedExpensesBillableAmount: 'Оценка суммы к оплате по затратам активности',
    ActivityEstimatedExpensesNonBillableAmount: 'ETC неоплачиваемые затраты активности',
    ActivityEstimatedHours: 'Расчетные часы активности',
    ActivityETCBilling: 'ETC сумма к оплате активности',
    ActivityETCCost: 'Ожидаемая стоимость завершения активности',
    ActivityETCLaborBilling: 'ETC сумма к оплате по трудозатратам активности',
    ActivityETCLaborCost: 'Ожидаемые трудозатраты активности',
    ActivityExpectedProfit: 'Ожидаемая прибыль активности',
    ActivityExpectedProfitPercentage: 'Ожидаемая прибыль активности, %',
    ActivityExpensesAmount: 'Фактические расходы активности',
    ActivityExpensesBillableAmount: 'Фактические оплачиваемые расходы активности',
    ActivityExpensesBilledAmount: 'Оплачено по затратам активности',
    ActivityExpensesNonBillableAmount: 'Неоплачиваемые расходы активности',
    ActivityHealthCondition_Text: 'Здоровье активности',
    ActivityHealthTypes: 'Здоровье активности',
    ActivityIsMilestone: 'Активность является вехой',
    ActivityNonBillableHours: 'Неоплачиваемые часы активности',
    ActivityProcessCondition_Text: 'Прогресс активности',
    ActivityProfit: 'Прибыль активности',
    ActivityProfitPercentage: 'Прибыль активности, %',
    ActivityProgress_Text: 'Прогресс активности',
    ActivityStartDateCondition_Text: 'Дата начала задачи',
    ActivityStatusCondition_Text: 'Статусы активностей',
    ActivityTotalBudget: 'Общий бюджет активности',
    ActivityTypeCondition_Text: 'Тип активности',
    ActivityTypes_Issue: 'Проблема',
    ActivityTypes_Request: 'Запрос',
    ActivityTypes_Task: 'Задача',
    ActivityTypesCondition_Text: 'Типы активностей',
    ActualCompletionDate_Text: 'Факт. дата окончания',
    add_filters: 'Добавить фильтры',
    AdvancedFilterTooltipContent_Text: 'Воспользуйтесь полным набором фильтров',
    AdvancedFilterTooltipTitle_Text: 'Дополнительные фильтры',
    AllActivities_Text: 'Задача',
    Apply_Text: 'Применить',
    AssigneeCondition_Text: 'Назначенные',
    AssigneeOption_Text: 'Назначены',
    AssigneeTeamCondition_Entity: 'команды',
    AssigneeUserCondition_Empty_Text: 'Нет назначений',
    AssigneeUserCondition_Entity: 'назначенные',
    BoolCustomField_No_Text: 'Нет',
    BoolCustomField_NotSelected_Text: 'Не выбрано',
    BoolCustomField_Yes_Text: 'Да',
    BudgetAndCosts_Filters_Group: 'Бюджет и стоимость',
    CategoriesCondition_Text: 'Категории',
    CategoryCondition_Empty_Text: 'Без категории',
    CategoryCondition_Entity: 'категории',
    CategoryCondition_Text: 'Категория',
    Clear_All_Text: 'Очистить фильтр',
    CompletedStatus_Text: 'Завершенные',
    constraints_filters_group: 'Ограничения',
    ContainMore_Text: 'Есть еще результаты, продолжайте набирать условие',
    CreationDate_Text: 'Дата создания',
    CustomerCondition_Empty_Text: 'Нет заказчика',
    CustomerCondition_Entity: 'заказчики',
    CustomerCondition_Text: 'Заказчики',
    CustomFieldsFilters_Group: 'Дополнительные поля',
    DraftCondition_Text: 'Черновики',
    DraftStatus_Text: 'Черновики',
    EndDate_Text: 'Дата оконч.',
    FilterByKeyword_Text: 'Поиск по ключевому слову',
    FilterByPeriod_Text: 'Фильтрация по фиксированным датам',
    FilterByTimeframe_Text: 'Фильтрация по временному интервалу',
    FilterTabs_Tab1: 'Статусы',
    FilterTabs_Tab2: 'Ресурсы и ограничения',
    FilterTabs_Tab3: 'Здоровье и прогресс',
    FilterTabs_Tab4: 'Проекты, заказчики и другое',
    FilterTabs_Tab5: 'Дополнительные  поля',
    Followed: 'Отслеживание',
    FollowedByMe_Text: 'Отслеживаемые активности',
    From_Text: 'от',
    general: 'Общие',
    HealthCondition_Text: 'Здоровье',
    HealthItemType_Bad: 'С проблемами',
    HealthItemType_Good: 'В порядке',
    HealthItemType_Medium: 'С высоким риском',
    HealthItemType_NotCalculated: 'Не рассчитано',
    HealthTooltip_Text: 'Здоровье - вычисляемый показатель успешного продвижения проекта или активности.',
    HealthTooltipLink_Text: 'Подробнее в онлайн-справке',
    HoursCondition_Text: 'Время',
    HoursFilters_Group: 'Время',
    HoursLeft: 'Оставшиеся часы',
    InProgressStatus_Text: 'Выполняемые',
    InThePast: 'В прошлом',
    InvalidDate: 'Дата должна быть в формате \'{0}\'.',
    Issue_Text: 'Проблема',
    KeepTyping_Text: 'Продолжайте набирать условие',
    ListCustomFieldCondition_Empty_Text: 'Не выбрано',
    ManualRange: 'Диапазон дат',
    Me: 'Я',
    Menu_Dates: 'Даты',
    Milestone_Text: 'Веха',
    MoneyCondition_Text: 'Деньги',
    More_Text: 'Дополнительные',
    MultiSelectCustomFieldCondition_Empty_Text: 'Не выбрано',
    NextMonth: 'Следующий месяц',
    NextWeek: 'Следующая неделя',
    no_filters: 'Нет фильтров для отображения',
    NoCategory: 'Без категории',
    NoMatch_Text: 'Подходящих условий не найдено',
    OnHoldStatus_Text: 'Приостановленные',
    PeopleCondition_Text: 'Люди',
    PinTooltip_Text: 'Закрепить',
    Portfolio_Status_Text: 'Статусы портфолио',
    PortfolioCondition_Empty_Text: 'Нет портфолио',
    PortfolioCondition_Entity: 'портфолио',
    PortfolioCondition_Text: 'Портфолио',
    PortfolioCreator_Text: 'Создатели портфолио',
    PortfolioCreatorCondition_Text: 'Создатель портфолио',
    PortfolioManager_Text: 'Менеджеры портфолио',
    PortfolioManagerCondition_Text: 'Менеджер портфолио',
    PreviousMonth: 'Предыдущий месяц',
    PreviousWeek: 'Предыдущая неделя',
    PreviousYear: 'Предыдущий год',
    PriorityCondition_Text: 'Приоритеты',
    Progress_Filters_Group: 'Прогресс',
    ProgressCondition_Entity: 'Прогресс',
    ProgressCondition_Text: 'Прогресс',
    Project_Text: 'Проект',
    ProjectActualBilling: 'Фактическая выручка проекта',
    ProjectActualCompletionDateCondition_Text: 'Факт. дата окончания проекта',
    ProjectActualCost: 'Факт. стоимость проекта',
    ProjectActualGreaterThanEstimated_Text: 'Проекты с превышением времени',
    ProjectActualHours: 'Фактические часы проекта',
    ProjectActualLaborBilling: 'Фактические оплачиваемые трудозатраты проекта',
    ProjectActualLaborCost: 'Фактические трудозатраты проекта',
    ProjectBillableHours: 'Оплачиваемые часы проекта',
    ProjectBilled: 'Оплачено по проекту',
    ProjectBilledLabor: 'Оплачено за трудозатраты проекта',
    ProjectBilledPercentage: 'Оплачено по проекту, %',
    ProjectBudgetVariance: 'Отклонение бюджета проекта',
    ProjectCondition_EmptyText: 'Проект не выбран',
    ProjectCondition_Entity: 'проекты',
    ProjectCondition_Text: 'Проекты',
    ProjectCostExceedBudget_Text: 'Проекты с превышением бюджета',
    ProjectCreationDateCondition_Text: 'Дата создания проекта',
    ProjectCreator_Text: 'Создатели проекта',
    ProjectCreatorCondition_Text: 'Создатель проекта',
    ProjectCustomFieldCondition_Text: 'Дополнительные поля проекта',
    ProjectDuration: 'Длительность проекта',
    ProjectEACBillableExpenses: 'EAC оплачиваемые затраты активности проекта',
    ProjectEACBilling: 'EAC сумма к оплате проекта',
    ProjectEACCost: 'Ожидаемая итоговая стоимость проекта',
    ProjectEACExpenses: 'EAC затраты проекта',
    ProjectEACLaborBilling: 'EAC сумма к оплате по трудозатратам проекта',
    ProjectEACLaborCost: 'EAC трудозатраты проекта',
    ProjectEACNonBillableExpenses: 'EAC неоплачиваемые затраты проекта',
    ProjectEndDateCondition_Text: 'Дата окончания проекта',
    ProjectEstimatedExpensesAmount: 'Ожидаемые расходы проекта',
    ProjectEstimatedExpensesBillableAmount: 'Оценка суммы к оплате по затратам проекта',
    ProjectEstimatedExpensesNonBillableAmount: 'ETC неоплачиваемые затраты проекта',
    ProjectEstimatedHours: 'Расчетные часы проекта',
    ProjectETCBilling: 'ETC сумма к оплате проекта',
    ProjectETCCost: 'Ожидаемая стоимость завершения проекта',
    ProjectETCLaborBilling: 'ETC сумма к оплате по трудозатратам проекта',
    ProjectETCLaborCost: 'Ожидаемые трудозатраты проекта',
    ProjectExpectedProfit: 'Ожидаемая прибыль проекта',
    ProjectExpectedProfitPercentage: 'Ожидаемая прибыль проекта, %',
    ProjectExpensesAmount: 'Фактические расходы проекта',
    ProjectExpensesBillableAmount: 'Фактические оплачиваемые расходы проекта',
    ProjectExpensesBilledAmount: 'Оплачено по затратам проекта',
    ProjectExpensesNonBillableAmount: 'Неоплачиваемые расходы проекта',
    ProjectHealthCondition_Text: 'Здоровье проекта',
    ProjectHealthTypes: 'Здоровье проекта',
    ProjectManager_Text: 'Менеджеры проектов',
    ProjectManagerCondition_Text: 'Менеджер проекта',
    ProjectMemberCondition_Text: 'Члены проекта',
    ProjectNonBillableHours: 'Неоплачиваемые часы проекта',
    ProjectPriorityCondition_Text: 'Приоритеты проекта',
    ProjectPriorityCondition_Text_Template: 'Пректы С %s приоритетом',
    ProjectProcessCondition_Text: 'Прогресс проекта ',
    ProjectProfit: 'Прибыль проекта',
    ProjectProfit_Text: 'Проекты с финансовыми потерями',
    ProjectProfitPercentage: 'Прибыль проекта, %',
    ProjectProgress_Text: 'Прогресс проекта',
    ProjectsAndTasksList_Title: 'Проекты и задачи',
    ProjectsCustomersAndMore_Filters_Group: 'Проекты, заказчики и другое',
    ProjectStartDateCondition_Text: 'Дата начала проекта',
    ProjectStatusCondition_Text: 'Статусы проектов',
    ProjectTotalBudget: 'Общий бюджет проекта',
    QuickFilterWatermark: 'Фильтруйте по...',
    range_condition_text: 'Период',
    Request_Text: 'Запрос',
    resource_types_condition_text: 'Ресурсы',
    resource_types_planning_condition_text: 'Проекты с ресурсами',
    resource_types_unnamed_label: 'Ресурсы',
    resource_types_user_label: 'Пользователи',
    ResourceRequestApprover_Text: 'Согласовывающее лицо',
    ResourceRequestCreator_Text: 'Автор запроса согласования',
    ResourceRequestStatuses_Approved: 'Согласовано',
    ResourceRequestStatuses_Rejected: 'Отклонено',
    ResourceRequestStatuses_WaitingForApproval: 'На согласовании',
    ResourceRequestStatuses_WithoutRequest: 'Без запроса',
    ResourceRequestStatusFilter_Text: 'Статус запросов ресурсов',
    resources_filters_group: 'Ресурсы',
    resources_requests_filters_group: 'Запросы на ресурсы',
    ResourcesAndConstraints_Filters_Group: 'Ресурсы и ограничения',
    roles_condition_text: 'Роли',
    RollBack_Text: 'Вернуться к предыдущим фильтрам',
    SaveFilters_Title: 'Сохраненные фильтры',
    set_filters: 'Установите фильтры, используя',
    set_filters_part2: 'иконку',
    skills_condition_text: 'Навыки',
    StartDate_Text: 'Дата начала',
    Statuses_Filters_Group: 'Статус',
    StatusesCountFormat: '7#{0} статус#{0} статуса#{0} статусов',
    Task_Text: 'Задача',
    TaskCondition_Entity: 'задачи',
    TaskCondition_Text: 'Задача ',
    TaskCostExceedBudget_Text: 'Задачи с превышением бюджета',
    TaskPriorityCondition_Entity: 'приоритеты задач',
    TaskPriorityCondition_Text: 'Приоритеты активности',
    TaskPriorityCondition_Text_Template: 'Задачи С %s приоритетом',
    TasksAssignedToMilestone_Text: 'Активности, входящие в вехи',
    teams_condition_text: 'Команды',
    TemplateCondition_Text: 'Шаблоны',
    TemplateStatus_Text: 'Шаблоны',
    ThisMonth: 'Текущий месяц',
    ThisWeek: 'Текущая неделя',
    ThisYear: 'Текущий год',
    To_Text: 'до',
    Today: 'Сегодня',
    TypesCondition_Text: 'Типы',
    UnpinTooltip_Text: 'Открепить',
    users_condition_text: 'Пользователи',
    Yesterday: 'Вчера',
};
